import { graphql } from '@gql';

export const PROJECT_ZONE_FRAGMENT = graphql(`
    fragment ProjectZoneFragment on ProjectZone {
        id
        name
        description
        parentZone {
            id
            name
        }
        exposureRating
        assetsCount
        createTime
        updateTime
    }
`);

export const STANDARD_PROFILE_FRAGMENT = graphql(`
    fragment StandardProfileFragment on StandardProfile {
        id
        name
        alias
        description
        standard {
            id
            name
            releasedAt
        }
    }
`);

export const GET_ZONE_STANDARD_PROFILES = graphql(`
    query getZoneStandardProfiles($pzid: ID!) {
        projectZoneStandardProfiles(where: { projectZoneID: $pzid }) {
            edges {
                node {
                    standardProfile {
                        ...StandardProfileFragment
                    }
                }
            }
        }
    }
`);

export const GET_ZONE_DETAILS = graphql(`
    query getZoneDetails($pzid: ID!, $pid: ID) {
        projectZones(where: { id: $pzid, projectID: $pid }) {
            edges {
                node {
                    ...ProjectZoneFragment
                }
            }
        }
        projectZoneStandardProfiles(where: { projectZoneID: $pzid }) {
            edges {
                node {
                    standardProfile {
                        ...StandardProfileFragment
                    }
                }
            }
        }
    }
`);

export const GET_SINGLE_ZONE_NAME_ONLY = graphql(`
    query getZoneName($pzid: ID!, $pid: ID) {
        projectZones(where: { id: $pzid, projectID: $pid }) {
            edges {
                node {
                    name
                }
            }
        }
    }
`);

export const GET_PROJECT_ROOT_ZONE = graphql(`
    query getRootZone($pid: ID!) {
        projectZones(where: { projectID: $pid, parentZoneIDIsNil: true }) {
            edges {
                node {
                    id
                    name
                }
            }
        }
    }
`);

export const GET_ALL_COMMENTS = graphql(`
    query GetComments($rqid: ID!, $spid: ID!, $pzid: ID!) {
        projectZoneStandardProfileRequirementCommentsGet(
            requirementID: $rqid
            standardProfileID: $spid
            projectZoneID: $pzid
        ) {
            ...Comment
        }
    }
`);
